// import { Client } from '@opanuj/shared';
// import * as shared from '@opanuj/shared'
import { Client } from '@opanuj/shared/types';
import { ref } from 'firebase/database';
import { useDatabase } from './useDatabase';
import { useListVals, useObjectVal } from 'react-firebase-hooks/database';
import { withDefaultList, withDefaultObject } from './defaults';

export const useClientsList = (): [Client[], boolean, Error | undefined] => {
	const database = useDatabase();
	const [clients, loading, error] = useListVals<Client>(ref(database, 'clients'), { keyField: 'id' });
	return [withDefaultList(clients), loading, error] as const;
}

export const useClients = (): [{ [uid: string]: Client }, boolean, Error | undefined] => {
	const database = useDatabase();
	const [clients, loading, error] = useObjectVal<{ [uid: string]: Client }>(ref(database, 'clients'), { keyField: 'id' } );
	return [withDefaultObject(clients), loading, error] as const;
}